import { useHistory } from 'react-router-dom';
export var useAppIdFromURL = function () {
    var history = useHistory();
    var pathname = history.location.pathname;
    var pathNameArray = pathname.split('/');
    return pathNameArray[4];
};
export var useOrgIdFromURL = function () {
    var history = useHistory();
    var pathname = history.location.pathname;
    var pathNameArray = pathname.split('/');
    return pathNameArray[2];
};
